import React, { useState } from 'react';
import styles from "./voucher.module.less"
import { observer } from 'mobx-react-lite';
import { useStores } from '@/store/useStores';
import GoBackIcon from '@/assets/img/user_center/go_back.svg';
import { useNavigate } from 'react-router-dom';
import { Button, Input, message } from 'antd';
import service from '@/services/axios';
import sha256 from 'crypto-js/sha256';

const Voucher: React.FC = () => {
    const navigate = useNavigate();
    const { userInfoStore } = useStores();
    const [voucher, setVoucher] = useState('');

    const applyVoucher = async () => {
        console.log("apply voucher", voucher);
    }
    return (
        <div className={styles.settingsPage}>
            <div className={styles.goBack} onClick={() => navigate('/user')}>
                <img src={GoBackIcon} alt="go back" />
            </div>
            <div className={styles.content}>
                <div className={styles.mainTitle}>请输入兑换码</div>
                <div className={styles.settingsBox}>
                    <div className={styles.inputBox}>
                        <Input
                            placeholder="请输入兑换码"
                            className={styles.input}
                            value={voucher}
                            onChange={(e) => setVoucher(e.target.value)}
                        />
                        <Button
                            type="primary"
                            className={styles.applyBtn}
                            onClick={applyVoucher}>
                            兑换
                        </Button>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default observer(Voucher);
